// Events
import { MODAL_OPEN } from 'events';
import { component } from 'picoapp';
import Swiper, {
  A11y,
  Autoplay,
  Keyboard,
  Manipulation,
  Mousewheel,
  Navigation,
  Scrollbar,
} from 'swiper';

// Utils
import choozy from 'utils/choozy';
import { mobileOnlyFunction } from 'utils/device';
import { hide, show } from 'utils/node';
import { dispatch } from 'utils/theme';

Swiper.use([A11y, Autoplay, Navigation, Manipulation, Mousewheel, Scrollbar, Keyboard]);

const KEY_ENTER = 'Enter';
const KEY_SPACE = ' ';
const MEDIA_TYPE_VIDEO = 'video';

export default component(async (node, ctx) => {
  const {
    sliderMain,
    videoButtonThumb,
    thumbsBar,
    scrollbar,
    slide,
    thumbnail,
    overlay,
    moreButtonThumb,
  } = choozy(node);

  const slides = [].concat(slide);
  const thumbnails = [].concat(thumbnail);
  const videoButtons = [].concat(videoButtonThumb || []);

  const { fullscreenModalId } = node.dataset;

  const openFullscreen = (activeSlide, autoplayVideo = false) => {
    const props = {
      activeSlide,
      autoplayVideo,
    };

    ctx.emit(MODAL_OPEN, null, {
      id: fullscreenModalId,
      props,
    });

    dispatch('pdp-enlarge-main-image');
  };

  const carousel = new Swiper(sliderMain, {
    slidesPerView: 1,
    speed: 200,
    breakpoints: {
      1024: {
        speed: 1300,
      },
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    watchSlidesProgress: true,
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
  });

  const thumbsCarousel = new Swiper(thumbsBar, {
    slidesPerView: 7,
    direction: 'vertical',
    spaceBetween: 7,
  });

  carousel.on('slideChange', ({ activeIndex }) => {
    thumbsCarousel.slideTo(activeIndex);

    thumbnails.forEach((el) => {
      el.classList[+el.dataset.slideRef === activeIndex ? 'add' : 'remove']('active');
    });

    dispatch('pdp-change-main-image', { index: activeIndex });
  });

  thumbnails.forEach((el) => {
    el.addEventListener('click', () => {
      carousel.slideTo(+el.dataset.slideRef);
    });
  });

  videoButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const videoSlide = slides.find(
        (slideElement) => slideElement.dataset.slideType === MEDIA_TYPE_VIDEO,
      );
      if (videoSlide) {
        const activeSlide = +videoSlide.dataset.slide;

        carousel.slideTo(activeSlide);

        openFullscreen(activeSlide, true);
      }
    });
  });

  node.addEventListener('slider:touchStart', (e) => {
    if (e.detail.sliderEl === node) e.stopPropagation();
  });

  node.addEventListener('slider:touchEnd', (e) => {
    if (e.detail.sliderEl === node) e.stopPropagation();
  });

  node.addEventListener('video:play', () => {
    hide(overlay, scrollbar);
    mobileOnlyFunction(() => hide(thumbsBar));
  });

  node.addEventListener('video:ended', () => {
    show(overlay, scrollbar);
    mobileOnlyFunction(() => show(thumbsBar));
  });

  slides.forEach((slideElement) => {
    const index = parseInt(slideElement.dataset.slide, 10);
    const type = slideElement.dataset.slideType;

    const openSlide = () => {
      const autoplayVideo = type === MEDIA_TYPE_VIDEO;

      openFullscreen(index, autoplayVideo);
    };

    slideElement.addEventListener('click', openSlide);

    slideElement.addEventListener('keydown', (event) => {
      const isActivationKey = event.key === KEY_ENTER || event.key === KEY_SPACE;

      if (!isActivationKey) return;

      event.preventDefault();

      openSlide();
    });
  });

  moreButtonThumb?.addEventListener('click', () => {
    openFullscreen(6);
  });
});
